module.exports = __webpack_public_path__ + "static/media/groups.980f6ba7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/groups.jpg
// module id = 342
// module chunks = 0